import { messageValidationFailed } from 'owa-mail-compose-actions/lib/actions/messageValidationFailed';
import {
    INSERT_LINK_ERROR_CODE,
    FORGOTTEN_ATTACHMENTS_ERROR_CODE,
    PENDING_PERMISSION_ERROR_CODE,
    SHARING_ISSUE_ERROR_CODE,
} from 'owa-mail-compose-actions/lib/utils/blockDialog/validateErrorCodes';
import { orchestrator } from 'satcheljs';
import {
    composeValidationFailedForMessage,
    composeValidationFailedForMessageWithSharingIssueForceSend,
} from '../actions/internalActions';
import { ValidatedAttachmentType } from '../store/schema/ValidatedAttachmentType';
import { logBlockingDialogDataPoint } from '../utils/logBlockingDialogDataPoint';
import { logInsertLinksBlockDialogDatapoint } from '../utils/logInsertLinksBlockDialogDatapoint';

orchestrator(messageValidationFailed, ({ composeId, errorCode, forceContinue, isSend }) => {
    switch (errorCode) {
        case FORGOTTEN_ATTACHMENTS_ERROR_CODE:
            composeValidationFailedForMessage(
                composeId,
                forceContinue,
                ValidatedAttachmentType.ForgottenAttachments
            );
            break;
        case PENDING_PERMISSION_ERROR_CODE:
            composeValidationFailedForMessage(
                composeId,
                forceContinue,
                ValidatedAttachmentType.PendingPermissions
            );
            break;
        case INSERT_LINK_ERROR_CODE:
            logInsertLinksBlockDialogDatapoint(forceContinue, isSend);
            break;
        case SHARING_ISSUE_ERROR_CODE:
            logBlockingDialogDataPoint(composeId, forceContinue);
            // update forceSend in telemetry store and log the usage only when the mail gets sent
            composeValidationFailedForMessageWithSharingIssueForceSend(composeId, forceContinue);
            break;
    }
});
